/*
 * <<
 * Davinci
 * ==
 * Copyright (C) 2016 - 2017 EDP
 * ==
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * >>
 */

import React, {ChangeEvent, FormEvent, useState} from 'react'

import './Login.css'
import BasWechatScanLoginForm from "../../components/WechatScanLoginForm/BasWechatScanLoginForm";
import BasAccountPasswordLoginForm from "../../components/AccountPasswordLoginForm/BasAccountPasswordLoginForm";
import BasWechatCodeLoginForm from "../../components/WechatCodeLoginForm/BasWechatCodeLoginForm";
import {useIsMobile} from "../../hooks/useIsMobile";
import {FormattedMessage} from "react-intl";

export const BasLogin: React.FC = () => {
    const [wechatCode, setWechatCode] = useState(false);
    const isMobile = useIsMobile();
    return (
        <>
            <div className={'login-window'}>
                <div className={'login-mock'}>
                    <div style={{float: 'left', color: '#fff'}}>
                        <div style={{textAlign: 'center'}}>
                            <span onClick={() => setWechatCode(false)}
                                  className={`title-item ${!wechatCode && 'select-title-item'}`}>
                                <FormattedMessage id={'账号密码'} /><span className={'title-line'}/>
                            </span>
                            <span onClick={() => setWechatCode(true)}
                                  className={`title-item ${wechatCode && 'select-title-item'}`}>
                                <FormattedMessage id={'微信验证码'} /><span className={'title-line'}/>
                            </span>
                        </div>
                        <div style={{marginTop: '50px'}}>
                            <BasAccountPasswordLoginForm show={!wechatCode}/>
                            <BasWechatCodeLoginForm show={wechatCode}/>
                        </div>
                    </div>
                    {
                        !isMobile &&
                        <div style={{float: 'right'}}>
                            <BasWechatScanLoginForm/>
                        </div>
                    }

                </div>
            </div>
        </>
    )
}
export default BasLogin;
